module.exports = __webpack_public_path__ + "img/libro_reclamaciones.d4f66016.png";